import { TableDataConfig } from '@pt/api/assets/index.type'
import { AssetStatus } from '@pt/enums/assets'
import { getTranscodeStatus } from '@pt/api/assets/index'
import { AssetsTransProgress } from '@pt/api/assets/index.type'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getTransCodeAddPendingId(listData: TableDataConfig[]) {
  // 获取正在转码的id
  const transCodeId: string[] = []
  listData.forEach((item) => {
    if (
      item.status === AssetStatus.Transcoding ||
      item.status === AssetStatus.Pending
    ) {
      transCodeId.push(item.id)
    }
  })
  return { transCodeId }
}

export async function getTranscodeProgress(
  transCodeId: string[],
): Promise<{ data: AssetsTransProgress[]; update: boolean }> {
  const res = await getTranscodeStatus(transCodeId.join(','))
  const data = res.data.data ?? []

  // 需要更新列表数据
  const update = data?.some((item: AssetsTransProgress) => {
    return (
      item.status === AssetStatus.Active || item.status === AssetStatus.Error
    )
  })

  return { data, update }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function updateProgress(
  list: TableDataConfig[],
  data: AssetsTransProgress[],
) {
  return list.map((value: TableDataConfig) => {
    const _index = data.findIndex(
      (c: AssetsTransProgress) => c.asset_id === value.id,
    )
    if (_index !== -1 && data.length > 0) {
      value.progress = data[_index]?.progress ?? 0
    }
    return { ...value }
  })
}
